import Vue from 'vue';

export const User = {
  state: {
    user: {
      type: ''
    }
  },
  actions: {
    logoutUser ({ commit }) {
      commit('setUser', {});
    }
  },
  mutations: {
    setUser (state, user) {
      Vue.set(state, 'user', JSON.parse(JSON.stringify(user)));
    }
  },
  getters: {
    getUser (state) {
      return state.user;
    }
  }
};

export default User;
